<template>
  <div ref="refNavMenu" class="navbar">
    <div class="left-menu">
      <Logo ref="refLogo" v-if="$store.getters.topNav" />
      <TopNav />
    </div>
    <div ref="refPersonal" class="right-menu">
      <ThemeColor />
      <Kefu id="kefu" class="menu pr-10 pl-10" v-if="useKefu"/>
      <Msg id="msg" class="menu pr-10 pl-10" v-if="useMsg"/>
      <el-dropdown trigger="click" class="user-container">
        <div class="user-wrapper menu">
          <img :src="avatar" class="user-avatar">
          <span class="ml10">{{username}}</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/user/profile">
            <el-dropdown-item>个人中心</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Logo from '../Logo'
import Kefu from '@/components/Kefu'
import Msg from '@/components/Msg'
import TopNav from './top-nav'
import ThemeColor from '@/components/Theme/theme-color.vue';

export default {
  components: {TopNav, Logo, Kefu, Msg, ThemeColor},
  data() {
    return {
      useKefu: false,
      useMsg: false,
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'username',
      'avatar',
      'fullName',
      'roles',
      'device'
    ]),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('doToggleSideBar')
    },
    async logout() {
      this.$confirm('确定要退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('doLogout').then((data) => {
          location.href = data;
        })
      }).catch(() => {
      });
    }
  }
}
</script>

<style lang="less" scoped>
.navbar {
  overflow: hidden;
  position: relative;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
  -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
  display: flex;
  justify-content: space-between;

  .menu {
    cursor: pointer;

    &:hover {
      // 二者一样
      /*background-color: #810100!important;*/
      background: rgba(0, 0, 0, .25)
    }
  }

  .left-menu {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: left;
    padding-left: 10px;

    .hamburger {
      width: 50px;
      height: 100%;
    }
  }

  .right-menu {
    display: flex;
    justify-content: right;
    align-items: center;

    .user-container {
      width: auto;
      height: 100%;
      position: relative;
    }

    .user-wrapper {
      width: 100%;
      height: 100%;
      padding: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      color: #FFFFFF;

      .user-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
      }
    }
  }

  .profile {
    color: #ffffff;
    font-size: 14px;
  }
}
</style>
